export default __webpack_public_path__ + "static/VideoElements-e581a7c1e658177d208fb33b3fcf9491.mp4";